import type { ComputedRef } from 'vue';
import type { TTooltipProps } from '../components/TTooltip/TTooltip.types';
import { useClickOutside } from '@/composables/click';
import { computed, ref } from 'vue';

export const useTooltip = (trigger: ComputedRef<TTooltipProps['trigger']>) => {
  const isVisible = ref(false);
  let hideTimeout: ReturnType<typeof setTimeout> | null = null;

  const show = () => {
    isVisible.value = true;
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
  };
  const hide = () => (isVisible.value = false);
  const enqueueHide = () => {
    const HIDE_DELAY_IN_SECONDS = 0.1;
    hideTimeout = setTimeout(hide, HIDE_DELAY_IN_SECONDS * 1000);
  };

  const triggerHandlers = {
    hover: {
      onMouseenter: show,
      onMouseleave: enqueueHide,
    },
    click: {
      onClick: () => (isVisible.value ? hide() : show()),
    },
  };
  const triggerHandler = computed(() => triggerHandlers[trigger.value ?? 'hover']);

  const wrapperRef = ref<HTMLElement | null>(null);
  useClickOutside(() => wrapperRef.value, hide);

  return {
    isVisible,
    triggerHandler,
    wrapperRef,
  };
};
